import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../utl/models/Message";
import { MoneyState } from "../models/MoneyState";

const setMessage = (state: MoneyState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;